module.exports = __webpack_public_path__ + "assets/img/3213.052d0a73.png";